module.exports = __webpack_public_path__ + "static/img/img-xzgt.88fe62b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/img-xzgt.jpg
// module id = ABQ4
// module chunks = 0